<template>
    <div class="max-w-3xl mx-auto text-center pt-12">
        <h1 class="h1 mb-4" data-aos="fade-down" data-aos-delay="200">Foxway</h1>
        <p class="text-xl text-gray-400 mb-8" data-aos="fade-down" data-aos-delay="200">Deal Notification System
        </p>
        <div class="sm:max-w-xs mx-auto sm:max-w-0 sm:flex sm:justify-center" data-aos="fade-up"
                        data-aos-delay="5000">
            <div>
                <form :action="route('categories.index', 'realtime')">
                    <input type="submit"
                        class="n text-white bg-blue-500 hover:bg-blue-600 w-full mb-4 sm:w-auto sm:mb-0 cursor-pointer"
                        value="Get Started" />
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    export default {}

</script>
